import { CreditCardService } from '@wix/cashier-core/dist/src/services/CreditCard';
import {
  type ICreditCardServiceConfig,
  type ITokenizeCardData,
  type ITokenizeCardToken,
  type ITokenizeSavedCreditCardData,
} from '@wix/cashier-core/dist/src/services/CreditCard/types';
import { win } from '@wix/cashier-common/dist/src/utils/win';

const defaultBaseURLForPCI: string =
  win.location.origin === 'https://cashier.wix.com' ? 'https://cashier.wix.com' : undefined; // let it be defined by CC service

export const cardAPI = {
  tokenizeCard: (payload: ITokenizeCardData, serviceConfig: ICreditCardServiceConfig): Promise<ITokenizeCardToken> => {
    return new CreditCardService({
      ...serviceConfig,
      baseURLForPCI: serviceConfig.baseURLForPCI || defaultBaseURLForPCI,
    }).tokenizeCreditCard(payload);
  },
  tokenizeSavedCard: (
    cardId: string,
    data: ITokenizeSavedCreditCardData,
    serviceConfig: ICreditCardServiceConfig,
  ): Promise<ITokenizeCardToken> => {
    return new CreditCardService({
      ...serviceConfig,
      baseURLForPCI: serviceConfig.baseURLForPCI || defaultBaseURLForPCI,
    }).tokenizeSavedCreditCard(cardId, data);
  },
};
